import { Pipe, PipeTransform } from '@angular/core';
import { isNil } from 'lodash';

@Pipe({
  name: 'nullToEmptyStringPipe',
})
export class NullToEmptyStringPipe implements PipeTransform {
  transform<T>(value: T): T | string {
    return isNil(value) ? '' : value;
  }
}
